
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { X as XIcon } from 'lucide-react';

interface MultiSelectBadgeProps {
  value: string;
  onRemove: () => void;
}

const MultiSelectBadge: React.FC<MultiSelectBadgeProps> = ({ value, onRemove }) => (
  <Badge className="mr-1 mb-1" variant="secondary">
    {value}
    <button onClick={onRemove} className="ml-1 hover:bg-muted rounded-full">
      <XIcon size={14} />
    </button>
  </Badge>
);

export default MultiSelectBadge;
